import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalConfigurationEmployerActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Employer/EmployerBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalConfigurationEmployer"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalConfigurationEmployer"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalConfigurationEmployerActivity)
